import type { DevDocsBylineConnection } from '@confluence/dev-docs/entry-points/DevDocsBylineConnection.ts';
import { getDevDocsProviderIcon } from '@confluence/dev-docs/entry-points/DevDocsProviderIcon.ts';

import type { BylineConnectionIcon } from './getBylineConnectionIcons.ts';

/**
 * A synced page's source-control provider as `BylineConnectionIconStack`'s `additionalIcons`, so the
 * byline trigger and the preview panel footer summarise the same connections.
 */
export const getDevDocsConnectionIcons = (
	connection: DevDocsBylineConnection | null,
): BylineConnectionIcon[] | undefined => {
	const icon = getDevDocsProviderIcon(connection);
	return icon ? [icon] : undefined;
};
